/**
 * 채팅 팝업 창 열기 — 단일 구현.
 * (이전에는 ChatPage·ChatSidebar·OrganizationSidebar·useWebSocket 에 같은 함수가 4벌 있었다)
 *
 * - 같은 방은 같은 창 이름(chat_popup_{roomId})을 쓴다.
 * - 이 창이 띄운 팝업은 레지스트리에 기억해, 새 메시지 자동 팝업이 이미 열린 창을 같은 URL 로 다시 탐색해
 *   입력 중 내용을 날리지 않게 하고, 팝업이 포커스를 갖고 있으면 '보고 있는 중' 으로 판정한다.
 */
export const CHAT_POPUP_WIDTH = 400;
export const CHAT_POPUP_HEIGHT = 600;

export function chatPopupName(roomId: number): string {
  return `chat_popup_${roomId}`;
}

const popupsByRoom = new Map<number, Window>();

function livePopup(roomId: number): Window | null {
  const popup = popupsByRoom.get(roomId);
  if (!popup || popup.closed) {
    popupsByRoom.delete(roomId);
    return null;
  }
  return popup;
}

/** 팝업을 (다시) 열고 앞으로 가져온다. 차단되면 null */
export function openChatPopup(roomId: number): Window | null {
  const left = window.screenX + window.outerWidth - CHAT_POPUP_WIDTH - 20;
  const top = window.screenY + 80;

  const popup = window.open(
    `/chat/popup/${roomId}`,
    chatPopupName(roomId),
    `width=${CHAT_POPUP_WIDTH},height=${CHAT_POPUP_HEIGHT},left=${left},top=${top},resizable=yes,scrollbars=yes`
  );

  if (popup) {
    popupsByRoom.set(roomId, popup);
    popup.focus();
  }

  return popup;
}

/** 이미 열려 있으면 앞으로만 가져오고, 없을 때만 새로 연다. 차단되면 null */
export function openChatPopupIfNeeded(roomId: number): Window | null {
  const existing = livePopup(roomId);
  if (existing) {
    existing.focus();
    return existing;
  }
  return openChatPopup(roomId);
}

/** 이 창이 띄운 해당 방 팝업이 열려 있고 포커스를 갖고 있는지 (같은 오리진이라 접근 가능) */
export function isChatPopupFocused(roomId: number): boolean {
  const popup = livePopup(roomId);
  if (!popup) return false;
  try {
    return popup.document.visibilityState === "visible" && popup.document.hasFocus();
  } catch {
    return false;
  }
}
